module.exports = __webpack_public_path__ + "static/media/icon-loading-white.bf6fc4a1.svg";